// extracted by mini-css-extract-plugin
export default {"popoverContentWrapper":"gzdzzd3noL4JbUXdWmF2","owner":"bOdT92fuE23WeP90NmqN","wrapper":"HKENIajObxWtpIap9lJa","ownersCountTag":"hR4O6QA3vM8K7oeay3Ex"};